import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { useEffect, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { fromPaymentMethod, useAppDispatch } from '../../store';
import { Order } from '../../models';
import PaymentForm from '../../components/payment-information-section/payment-method/stripe/PaymentForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);

const StripeCheckout = forwardRef<
{ submitPayment:() => void },
{
  orderResponse?: Order;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}
>(({ orderResponse, onSuccess, onError }, ref) => {
    const dispatch = useAppDispatch();
    const stripePaymentConfig = useSelector(fromPaymentMethod.selectStripePaymentConfig);
    const [options, setOptions] = useState<StripeElementsOptions | undefined>(undefined);

    useEffect(() => {
      dispatch(fromPaymentMethod.doGetClientSecret());
    }, [dispatch]);

    useEffect(() => {
      if (stripePaymentConfig !== undefined && stripePaymentConfig !== null && !options) {
        setOptions({
          clientSecret: orderResponse?.stripeClientSecret,
          customerSessionClientSecret: stripePaymentConfig.customerSessionClientSecret,
        });
      }
    }, [stripePaymentConfig, options, orderResponse?.stripeClientSecret]);

    return (
      <>
        {options && (
        <Elements stripe={stripePromise} options={options}>
          <PaymentForm
            ref={paymentFormRef => {
              if (ref && 'current' in ref) {
                ref.current = {
                  submitPayment: () => paymentFormRef?.handleSubmit(),
                };
              } else if (typeof ref === 'function') {
                ref({
                  submitPayment: () => paymentFormRef?.handleSubmit(),
                });
              }
            }}
            mode="payment"
            onSuccess={onSuccess}
            onError={onError}
          />
        </Elements>
        )}
      </>
    );
  });

export default StripeCheckout;
